import createIcon from '../../createIcon';

/**
 * @component @name PhotoSizeSelectSmall
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjMgMTVIMjFWMTdIMjNWMTVaTTIzIDExSDIxVjEzSDIzVjExWk0yMyAxOUgyMVYyMUMyMiAyMSAyMyAyMCAyMyAxOVpNMTUgM0gxM1Y1SDE1VjNaTTIzIDdIMjFWOUgyM1Y3Wk0yMSAzVjVIMjNDMjMgNCAyMiAzIDIxIDNaTTMgMjFIMTFWMTVIMVYxOUMxIDIwLjEgMS45IDIxIDMgMjFaTTMgN0gxVjlIM1Y3Wk0xNSAxOUgxM1YyMUgxNVYxOVpNMTkgM0gxN1Y1SDE5VjNaTTE5IDE5SDE3VjIxSDE5VjE5Wk0zIDNDMiAzIDEgNCAxIDVIM1YzWk0zIDExSDFWMTNIM1YxMVpNMTEgM0g5VjVIMTFWM1pNNyAzSDVWNUg3VjNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PhotoSizeSelectSmall = createIcon('PhotoSizeSelectSmall', [
  [
    'path',
    {
      d: 'M23 15H21V17H23V15ZM23 11H21V13H23V11ZM23 19H21V21C22 21 23 20 23 19ZM15 3H13V5H15V3ZM23 7H21V9H23V7ZM21 3V5H23C23 4 22 3 21 3ZM3 21H11V15H1V19C1 20.1 1.9 21 3 21ZM3 7H1V9H3V7ZM15 19H13V21H15V19ZM19 3H17V5H19V3ZM19 19H17V21H19V19ZM3 3C2 3 1 4 1 5H3V3ZM3 11H1V13H3V11ZM11 3H9V5H11V3ZM7 3H5V5H7V3Z',
      key: 'lbs142',
    },
  ],
]);

export default PhotoSizeSelectSmall;
